import { Link } from 'react-router-dom';
import { animeList } from '@/mocks/anime';
import AnimeCard from '@/pages/home/components/AnimeCard';

export default function LatestSection() {
  const latest = animeList.slice(0, 8);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              最新更新
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              追番不等待
            </h2>
            <p className="text-sm text-foreground-500 mt-2">实时更新，第一时间获取最新番剧动态</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.map((anime) => (
            <AnimeCard key={anime.id} {...anime} />
          ))}
        </div>
      </div>
    </section>
  );
}